import { RESET_ALL as RESET_ON_LOGOUT, danger } from 'redux-store/reducers/common-reducer';

import { API, get } from 'utils/api';
import { createReducer } from 'utils/redux';
import { logError } from 'utils/log';
import { __t, applyTranslations } from 'utils/language';

import type {
  Action,
  Dispatch,
  SubcampaignCreator,
  ThunkAction
} from 'types';
import type { CreatorListReducerState } from '../types/CreatorList.type';

applyTranslations(require('./creators-list.i18n.json'));

const { CAMPAIGNS } = API.END_POINTS;

const LOADING = 'creatorsList/LOADING';
const LOADED = 'creatorsList/LOADED';
const RESET = 'creatorsList/RESET';

const initialState: CreatorListReducerState = {
  list: [],
  isLoading: false
};

const creatorsListLoaded = (list: Array<SubcampaignCreator>): Action => ({
  type: LOADED,
  payload: {
    list
  }
});

const creatorsListLoading = (isLoading: boolean): Action => ({
  type: LOADING,
  payload: {
    isLoading
  }
});

export const resetCreatorsList = (): Action => ({
  type: RESET
});

export const fetchCreatorsList = (campaignId: number): ThunkAction => async (dispatch: Dispatch) => {
  dispatch(creatorsListLoading(true));

  try {
    const url = CAMPAIGNS.getCreatorsList(campaignId);
    const response = await get(url, {}, { suppressGlobalNotification: true });

    dispatch(creatorsListLoaded(response.data));
  } catch (e) {
    logError(e);
    dispatch(danger(__t('creators_list.fetch_error')));
  } finally {
    dispatch(creatorsListLoading(false));
  }
};

export default createReducer<CreatorListReducerState, any>('creatorsList', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [LOADING]: (state, { isLoading }) => ({
    ...state,
    isLoading
  }),
  [LOADED]: (state, { list }) => ({
    ...state,
    list,
    isLoading: false
  })
});
